export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Miercoles_eng.6f6da7c1.png";